import {
  CartSummaryProps,
  getItemsQuantity,
  useCartSummary,
} from "@/app/cartContext";

export const getProductWord = (count: number): string => {
  if (count === 0 || count >= 5) return "товаров";
  if (count > 1) return "товара";
  return "товар";
};

export const useGetCartSummary = (items: CartSummaryProps) => {
  const { total } = useCartSummary();
  const count = getItemsQuantity(items);
  const products = getProductWord(count);

  return {
    header: `${count} ${products} на ${total} ₽`,
    products,
    productsSum: total,
    count,
  };
};
